import { fCurrencyUSD, fCurrencyUSDExtended } from '@/utils/formatNumber';
import { ApexOptions } from 'apexcharts';
import Chart from 'react-apexcharts';

type CostMetricsProps = {
  data?: {
    date: number;
    total: number;
    storage: number;
    onDemand: number;
    spot: number;
  }[];
};

const CostMetrics = ({ data }: CostMetricsProps) => {
  const isData = data && data.length > 0;

  // แปลงข้อมูลสำหรับ series
  const series: ApexAxisChartSeries = [
    {
      name: 'On Demand',
      data: data?.map((item) => item.onDemand) || [],
      color: 'hsl(var(--chart-1))',
    },
    {
      name: 'Spot',
      data: data?.map((item) => item.spot) || [],
      color: 'hsl(var(--chart-4))',
    },
    {
      name: 'Storage',
      data: data?.map((item) => item.storage) || [],
      color: 'hsl(var(--chart-3))',
    },
  ];

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      height: 300,
      stacked: true,
      toolbar: {
        show: true,
        tools: {
          download: false,
        },
      },
      zoom: {
        enabled: true,
      },
    },
    legend: {
      markers: {
        shape: 'circle',
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 2,
        borderRadiusApplication: 'end', // 'around', 'end'
        borderRadiusWhenStacked: 'last', // 'all', 'last'
        dataLabels: {
          hideOverflowingLabels: true,
          total: {
            enabled: true,
            formatter: function (total) {
              if (!total) return '';
              return fCurrencyUSD(total);
            },
          },
        },
      },
    },
    xaxis: {
      type: 'datetime',
      categories: data?.map((item) => item.date) || [],
      labels:{
        datetimeUTC: false,
      }
    },
    yaxis:{
      labels:{
        formatter(val) {
          return fCurrencyUSDExtended(val);
        },
      }
    },
    fill: {
      opacity: 1,
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
  };

  return (
    <div>
      {isData ? (
        <Chart options={options} series={series} type="bar" height={300} />
      ) : (
        <div className="text-center text-sm text-muted-foreground">No data</div>
      )}
    </div>
  );
};

export default CostMetrics;
